import { Component, OnInit, Input } from '@angular/core';
import { TransactionsService } from '../../../../shared/services/transactions-service';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { DateTime } from 'luxon';
import { MatSelectChange } from '@angular/material/select';
import { KlyantService } from 'src/app/shared/services/klyant.service';
import { CaseService } from 'src/app/shared/services/case.service';
import { environment } from 'src/environments/environment';
import { InvoiceService } from 'src/app/shared/services/invoice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-transaction',
  templateUrl: './add-transaction.component.html',
  styleUrls: ['./add-transaction.component.scss']
})
export class AddTransactionComponent implements OnInit {

  @Input() caseId : number;
  @Input() caseTypeId : number;

  transactionTypeId : number = 0;
  case: any;
  invoice: any;

  officeAccountList: any[] = [];
  clientAccountList: any[] = [];
  transactionTypes: any[] = [];
  methodsOfVerification: any[] = [];
  descriptionTextOptions: any[] = [];
  selectedTransactionType: any = null;

  invoices: any[] = [];

  addingTransactions: boolean = false;
  selectedType: string = '';

  hasError: boolean = false;
  errorMessage: any[] = []; 

  defaultTransferToAccountId: number =0;
  chequeTransactionTypeId: number;

  newTransactionDetails = this.fb.group({
    type: [null, Validators.required],
    fromBankAccountId: [null],
    toBankAccountId: [null],
    fundsReceivedFrom: [null],
    fundsReceivedDate: [null],
    value: [null, Validators.required],
    narrative: ['', Validators.required],
    description: ['', Validators.required],
    transactionTypeId: [null],
    transactionTypeOther: [null],
    privateClientTypeId: [null],
    methodOfVerificationId: [null],
    thirdPartyFeeId: [null],
    payeeName: [null],
    transactionDateTime: [null],
    invoiceId: [null],
    chequeDetails: [null]
  }, { });

  constructor(
              private fb: UntypedFormBuilder,
              private transactionsService: TransactionsService,
              public activeModal: NgbActiveModal,
              private klyantService: KlyantService,
              private caseService: CaseService,
              private invoiceService: InvoiceService) {




  }

  ngOnInit(): void {

        this.caseService.getCase(this.caseId).subscribe((result) => {
      this.case = result;
      this.setDefaults();
    });

    /*this.invoiceService.getInvoice(this.caseId).subscribe((result) => {
      this.invoice = result;
    });*/

    this.klyantService.getOfficeAccounts().subscribe((results) => {
      this.officeAccountList = results;

      this.klyantService.getDefaultTransferToAccountId().subscribe((result:any) => {
        this.defaultTransferToAccountId = result;
      });

    }); 

    this.klyantService.getClientAccounts().subscribe((results) => {
      this.clientAccountList = results;
    }); 
    
    this.transactionsService.getTransactionTypes().subscribe((results:any) => {
      this.transactionTypes = results;
      this.setDefaults();
    });

    this.transactionsService.getMethodsOfVerification().subscribe((results:any) => {
      this.methodsOfVerification = results;      
      this.setDefaults();
    });

    this.invoiceService.getAllKlyantInvoices(this.caseId).subscribe((results : any) => {
      this.invoices = results.invoices;
      if(this.invoices.length == 1){
        this.invoice = this.invoices[0];
        this.newTransactionDetails.controls['invoiceId'].patchValue(this.invoices[0].id);
      }
    });

    this.klyantService.getChequeTransactionTypeId().subscribe((result:any) => {
      this.chequeTransactionTypeId = result;
    });
  }

  hasKlyantInvoice() {

    if (this.invoices.length > 0){
      return true;
    }
    else {
      return false;
    }
  }

  addTransaction() {
    this.addingTransactions = true;
    this.transactionsService.addTransaction(this.caseId, this.newTransactionDetails.value).subscribe((response : any) => {      
      this.activeModal.close(true);
      this.addingTransactions = false;
      this.hasError = false;
    }, (error: any) => {            
      this.addingTransactions = false;
      this.hasError = true;
      this.errorMessage = error.error;
    });
  }

  typeChange(event: Event) {
  const value = +(event.target as HTMLInputElement).value;
  this.transactionTypeId = value;
  this.newTransactionDetails.controls['type'].patchValue(value);

  if (this.transactionTypeId == 1)
    this.selectedType = "Monies In";
  else if (this.transactionTypeId == 2)
    this.selectedType = "Transfer";
  else if (this.transactionTypeId == 3)
    this.selectedType = "Monies Out";

  this.setDefaults();
}

  showOtherTransactionType() {    
    let ttId = this.newTransactionDetails.value.transactionTypeId;
    let tt:any = this.transactionTypes.filter(x => x.transactionTypeId == ttId);    
    return tt[0] && tt[0].isOther;
  }

  fundsReceivedChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.newTransactionDetails.controls['fundsReceivedFrom'].patchValue(value);
  }

  onDescriptionPreset(event: any) {
  if (event.target.value) {
      this.newTransactionDetails.controls['description'].setValue(event.target.value);
    }
  }

  setDefaults() {

    let caseTypeId = this.caseTypeId;
    let typeId = this.newTransactionDetails.value.type;

    this.newTransactionDetails.controls['transactionTypeId'].patchValue(null);
    this.newTransactionDetails.controls['transactionTypeOther'].patchValue(null);
    
    // Set the default transaction type if we have one (if we have more than one for this case type, we'll end up with the last one)
    // this.transactionTypes.forEach((tt:any) => {      
    //   if (tt.transactionTypeDefaults && tt.transactionTypeDefaults.length > 0) {        
    //     if (tt.transactionTypeDefaults[0].caseTypeId == caseTypeId && tt.transactionTypeDefaults[0].transactionDirectionId == typeId) {
    //       this.newTransactionDetails.controls['transactionTypeId'].patchValue(tt.transactionTypeDefaults[0].transactionTypeId);
    //     }
    //   }
    // });

    this.newTransactionDetails.controls['methodOfVerificationId'].patchValue(environment.klyant.defaultMethodOfVerificationId);

    this.descriptionTextOptions = [];

    if(this.case) {
      this.newTransactionDetails.controls['narrative'].patchValue(this.case.caseData.caseReference);    
    }

    this.newTransactionDetails.controls['fundsReceivedFrom'].patchValue('');
    this.newTransactionDetails.controls['fundsReceivedDate'].patchValue(DateTime.local().toFormat('yyyy-MM-dd'));    

    // Default selectable text options for Narrative
    if (caseTypeId == 1) {
      if (typeId == 1) {
        this.descriptionTextOptions.push({text: 'Completion Funds', value: 'Completion Funds'})
        this.descriptionTextOptions.push({text: 'Shortfall Funds', value: 'Shortfall Funds'})
      }
    }
    else if (caseTypeId == 6) {
      if (typeId == 1) {        
        this.descriptionTextOptions.push({text: 'Completion Sale Funds', value: 'Completion Sale Funds'})
        this.descriptionTextOptions.push({text: 'Negative Equity', value: 'Negative Equity'})
      }
    }
    else if (caseTypeId == 8) {
      if (typeId == 1) {        
        this.descriptionTextOptions.push({text: 'Completion Purchase Funds', value: 'Completion Purchase Funds'})
        this.descriptionTextOptions.push({text: 'Negative Equity', value: 'Negative Equity'})
      }
    }

    // Default transactionDateTime to now
    this.newTransactionDetails.controls['transactionDateTime'].patchValue(DateTime.local().toFormat('yyyy-MM-dd'));

    if(typeId == 2) // Transfers must have an invoice selected
    {
      this.newTransactionDetails.controls['invoiceId'].setValidators([Validators.required]);
      this.newTransactionDetails.controls['toBankAccountId'].patchValue(this.defaultTransferToAccountId);
    }
    else
      this.newTransactionDetails.controls['invoiceId'].clearValidators();
  }

  showControl(controlName:string) {

    if (controlName == undefined) {
      return false;
    }

    if (this.newTransactionDetails.value.type == null) {
      return false;
    }

    let typeId = this.newTransactionDetails.value.type;

    switch (controlName) {

      case 'fromBankAccountId':
        if (typeId == 1) // Monies In
          return false;
        else 
          return true;
      case 'toBankAccountId':
        if (typeId == 3) // Monies Out
          return false;
        else 
          return true;
      case 'transactionTypeId':
        if (typeId == 2) // Transfer (so we don't have BACS, Cheque, or whatever)
          return false;
        else 
          return true;
      case 'transactionTypeOther':
        if (typeId == 2) // Transfer (so we don't have BACS, Cheque, or whatever)
          return false;
        else 
          return true;
      case 'fundsReceivedFrom':
        if (typeId == 1) // Monies In
          return true;
        else 
          return false;
      case 'fundsReceivedDate':
        if (typeId == 1) // Monies In
          return true;
        else 
          return false;
      case 'value':
        return true;
      case 'payeeName':
        if (typeId == 3) // Monies Out
          return true;
        else 
          return false;
      case 'narrative':
        return true;
      case 'description':
        return true;
      case 'methodOfVerificationId':   
        if (typeId == 3) // Monies Out
          return true;
        else 
          return false;
      case 'transactionDateTime':
        if (typeId == 1) // Monies In
          return false;
        else 
          return true;
      case 'invoiceId':
          if (typeId == 2) // Transfer
            return true;
          else 
            return false; 
      case 'chequeDetails':
        if (typeId == 2) // Transfer
          return false;
        else 
          return true; 
    }

    return false;
  }

  showChequeDetails() {    
    let ttId = this.newTransactionDetails.value.transactionTypeId;
    return ttId == this.chequeTransactionTypeId;
  }

}
